"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEYTYPE_ED25519 = exports.KEYTYPE_K256 = exports.NETWORK_SOLANA = exports.NETWORK_EVM = exports.LIT_PREFIX = exports.CHAIN_ETHEREUM = void 0;
exports.CHAIN_ETHEREUM = 'ethereum';
exports.LIT_PREFIX = 'lit_';
exports.NETWORK_EVM = 'evm';
exports.NETWORK_SOLANA = 'solana';
exports.KEYTYPE_K256 = 'K256';
exports.KEYTYPE_ED25519 = 'ed25519';
//# sourceMappingURL=constants.js.map